import React from 'react';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { Download } from 'lucide-react';
export function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const handleDownloadResume = () => {
    window.open('https://heyzine.com/flip-book/2eee1db339.html', '_blank');
  };
  return <div id="hero" className="relative min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0f172a] via-[#1e3a8a] to-[#1e293b] text-white overflow-hidden" data-id="element-137">
      {/* Animated Silver Gradient Overlay */}
      <div className="absolute inset-0 opacity-30" data-id="element-138">
        <div className="absolute top-0 right-0 w-[800px] h-[800px] bg-gradient-to-bl from-gray-300/40 via-transparent to-transparent blur-3xl animate-pulse" data-id="element-139"></div>
        <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-gradient-to-tr from-blue-300/30 via-transparent to-transparent blur-3xl animate-pulse" style={{
        animationDelay: '1s'
      }} data-id="element-140"></div>
      </div>

      {/* Metallic Grid Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-141">
        <div className="absolute inset-0 bg-[linear-gradient(rgba(192,192,192,0.1)_1px,transparent_1px),linear-gradient(90deg,rgba(192,192,192,0.1)_1px,transparent_1px)] bg-[size:50px_50px]" data-id="element-142"></div>
      </div>

      {/* Silver Shine Effect */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -skew-x-12 animate-shimmer" data-id="element-143"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 z-10 pt-20 pb-16" data-id="element-144">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center" data-id="element-145">
          {/* Photo Section */}
          <FadeIn delay={0.1} className="lg:col-span-2 flex justify-center lg:justify-end" data-id="element-146">
            <div className="relative group" data-id="element-147">
              {/* Metallic Glow Behind Photo */}
              <div className="absolute inset-0 bg-gradient-to-br from-gray-300/40 via-blue-300/30 to-gray-400/40 rounded-2xl transform rotate-3 blur-2xl group-hover:blur-3xl transition-all duration-500" data-id="element-148"></div>

              {/* Silver Border Effect */}
              <div className="absolute -inset-1 bg-gradient-to-br from-gray-300 via-gray-100 to-gray-400 rounded-2xl opacity-75 blur-sm" data-id="element-149"></div>

              <img src="https://cdn.magicpatterns.com/uploads/1WAds7BtrN1Ci8vKPYQyAK/Albert_Previte.jpg" alt="Albert Previte" className="relative w-64 h-64 md:w-80 md:h-80 lg:w-96 lg:h-96 object-cover rounded-2xl shadow-2xl border-4 border-white/20 backdrop-blur-sm" data-id="element-150" />

              {/* Shine Overlay on Hover */}
              <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl" data-id="element-151"></div>
            </div>
          </FadeIn>

          {/* Content Section */}
          <div className="lg:col-span-3 text-center lg:text-left" data-id="element-152">
            <FadeIn delay={0.2} data-id="element-153">
              <h2 className="text-transparent bg-clip-text bg-gradient-to-r from-gray-200 via-white to-gray-300 font-medium tracking-wider uppercase text-sm mb-4 drop-shadow-lg" data-id="element-154">
                Strategic Advisor & Operations Executive
              </h2>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-155">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold tracking-tight mb-6 leading-tight text-transparent bg-clip-text bg-gradient-to-r from-white via-gray-100 to-white drop-shadow-2xl" data-id="element-156">
                Strategic Program & Operations Leader Driving Large-Scale
                Transformation
              </h1>
            </FadeIn>

            <FadeIn delay={0.4} data-id="element-157">
              <p className="text-base md:text-lg lg:text-xl text-gray-200 mb-10 leading-relaxed drop-shadow-lg" data-id="element-158">
                17+ years leading $50M+ programs across government and
                commercial organizations—delivering cost savings, operational
                efficiency, and measurable results through disciplined
                governance, change leadership, and execution excellence.
              </p>
            </FadeIn>

            <FadeIn delay={0.5} className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start flex-wrap" data-id="element-159">
              <Button variant="secondary" onClick={() => scrollToSection('experience')} className="min-w-[160px] shadow-xl shadow-blue-900/30 hover:shadow-2xl hover:shadow-blue-800/40 transition-shadow" data-id="element-160">
                View Experience
              </Button>
              <Button variant="outline" onClick={() => scrollToSection('contact')} className="min-w-[160px] backdrop-blur-sm bg-white/5 hover:bg-white/10 shadow-xl shadow-gray-900/30" data-id="element-161">
                Contact Me
              </Button>
              <Button variant="primary" onClick={handleDownloadResume} className="min-w-[160px] bg-gradient-to-r from-gray-200 to-gray-300 text-[#1e3a8a] hover:from-white hover:to-gray-200 border-none shadow-xl shadow-gray-400/20 hover:shadow-2xl hover:shadow-gray-300/30 transition-all font-semibold" data-id="element-162">
                <Download className="mr-2 w-5 h-5" data-id="element-163" />
                View Resume
              </Button>
            </FadeIn>
          </div>
        </div>
      </div>
    </div>;
}